import {Injectable} from '@angular/core';
import {CanActivate, UrlTree} from '@angular/router';
import {UserService} from './user.service';
import {ToastrService} from 'ngx-toastr';
import { translate } from '@ngneat/transloco';

@Injectable({
	providedIn: 'root'
})
export class UserGuard implements CanActivate {
	constructor(private service: UserService, private toastr: ToastrService) {}
	canActivate(): boolean | UrlTree {
		const cond = !!this.service.user;
		!cond && this.toastr.error(translate('userGuard.selectTestingUser'), translate('userGuard.noUserSelected'));
		return cond;
	}
}
